$(document).ready(function () {
  $(document).on("click", ".quantity_dropdown_title", function (e) {
    $(this).closest(".quantity_dropdown").toggleClass("_open");
  });

  $(document).on("click", "[data-cart-quantity]", function (e) {
    e.preventDefault();
    const value = $(this).data("item");
    const $itemElement = $(this).closest("[data-cart-item]");
    const $quantityDropdown = $itemElement.find(".quantity_dropdown");
    const productId = $itemElement.data("id");
    const itemIndex = $itemElement.data("index");

    if (!productId) return false;

    const data = {
      line: itemIndex,
      quantity: value,
      sections: ["cart-popup", "main-cart"],
    };

    $.ajax({
      url: "/cart/change",
      method: "post",
      data,
      dataType: "json",
      success: (data) => {
        replaceCartPopup(data.sections["cart-popup"]);

        replaceMainCart(data.sections["main-cart"]);

        updateCartItemCount();
        $(".quantity_dropdown._open").removeClass("_open");
      },
      error: (error) => {
        $(".quantity_dropdown._open").removeClass("_open");
        
        showError($itemElement.closest("[data-cart-list]"), error.responseJSON.errors);
      },
    });
  });

  function showError(item, error) {
    item.find('._error_block').html(error);
    setTimeout(function () {
      $("._error_block").html('');
    }, 3000);
  }

  $(document).on("click", "[data-remove-product]", function (e) {
    e.preventDefault();
    const $itemElement = $(this).closest("[data-cart-item]"); //".popup_cart_item" 
    const productId = $itemElement.data("id");
    const itemIndex = $itemElement.data("index");

    if (!productId) return false;

    const data = {
      line: itemIndex,
      quantity: 0,
      sections: ["cart-popup", "main-cart"],
    };

    $.ajax({
      url: "/cart/change",
      method: "post",
      data,
      dataType: "json",
      success: (data) => {
        //Replace cart popup
        replaceCartPopup(data.sections["cart-popup"]);

        //Replace main cart
        replaceMainCart(data.sections["main-cart"]);

        updateCartItemCount();
      },
      error: (error) => {
        console.error("Произошла ошибка при удалении товара", error);
      },
    });
  });

  function replaceCartPopup(html) {
    const targetElement = $("#popup_cart .popup_cart_wrap");
    const sourceElement = $(html).find(
      ".popup_cart_wrap"
    );
    targetElement.replaceWith(sourceElement);
  }

  function replaceMainCart(html) {
    if ($('.section_cart').length < 1) return false;
    const targetElement = $(".section_cart .section_cart_wrap");
    const sourceElement = $(html).find(
      ".section_cart_wrap"
    );
    targetElement.replaceWith(sourceElement);
  }

  function updateCartItemCount() {
    $.ajax({
      url: "/cart.js",
      dataType: "json",
      success: function (cartData) {
        var itemCount = cartData.item_count;
        // Обновляем отображение количества товаров в шапке
        $(".header_cart_counter").text(itemCount);
        $(".header_cart_counter").removeClass("_hidden");
      },
      error: function (error) {
        console.error("Ошибка при получении данных о корзине:", error);
      },
    });
  }

  $(document).on('click', '[data-close-cart-popup]', () => {
    $('#popup_cart').removeClass('_active');
    $('.cart_overlay').removeClass('_active');
    $('body').removeClass('no_scroll');
  });
});